import { Text, Tooltip } from "@hightouch/htui";
import { format, formatDistanceToNowStrict } from "date-fns";

import { formatRelativeShort } from "src/utils/time";

type Props = {
  /** An ISO instant. */
  date: string;
  /** Leads the exact time in the tooltip, as in "Created Sep 3, 2026, 4:12 PM". */
  label?: string;
  /** "3h" rather than "3 hours ago", for a column of times. */
  isShort?: boolean;
};

/** "3 hours ago", with the exact time on hover. */
export const RelativeTime = ({ date, label, isShort = false }: Props) => {
  const value = new Date(date);
  const exact = format(value, "PPp");
  return (
    <Tooltip message={label ? `${label} ${exact}` : exact}>
      <Text as="span" size="sm" color="text.tertiary" whiteSpace="nowrap">
        {isShort
          ? formatRelativeShort(date, { addSuffix: false })
          : formatDistanceToNowStrict(value, { addSuffix: true })}
      </Text>
    </Tooltip>
  );
};
